let apiUrl: string = null;
let socketUrl: string = null;
let proxyUrl: string = null;

/****************************************************************************
 * API URL
 ****************************************************************************/

export const setApiUrl = (url: string) => {
    localStorage.setItem('api_url', url);
};

export const getApiUrl = () => {
    if (!apiUrl) {
        apiUrl = localStorage.getItem('api_url');
    }

    return apiUrl;
};

/****************************************************************************
 * SOCKET URL
 ****************************************************************************/

export const setSocketUrl = (url: string) => {
    localStorage.setItem('socket_url', url);
};

export const getSocketUrl = () => {
    if (!socketUrl) {
        socketUrl = localStorage.getItem('socket_url');
    }

    return socketUrl;
};

/****************************************************************************
 * PROXY URL
 ****************************************************************************/

export const setProxyUrl = (url: string) => {
    localStorage.setItem('proxy_url', url);
};

export const getProxyUrl = () => {
    if (!proxyUrl) {
        proxyUrl = localStorage.getItem('proxy_url');
    }

    return proxyUrl;
};
